import config from "@/common/config";
import {
  LANGUAGE_GROUP_ENGLISH,
  LANGUAGE_GROUP_FRENCH,
  LANGUAGE_GROUP_GERMAN
} from "@/common/language-groups";

import ApiService from "./api.service";

export const SUPPORTED_LANGUAGES = [
  LANGUAGE_GROUP_ENGLISH,
  LANGUAGE_GROUP_GERMAN,
  LANGUAGE_GROUP_FRENCH
];

export default {
  VERISON: config.api.versions.v2,

  /**
   * @param {string} language
   *
   * @returns {Promise<Record<string, string>[]>}
   */
  async fetch(language) {
    const response = await ApiService.get(`/workshop/irregular-verbs/${language}`, this.VERISON);

    return response.data.data;
  }
};
